<template>
  <div>
    <div class="serchBox">
      <!-- <div class="logoImg img">
        <img src="../../assets/img/logo-p.png" alt="" srcset="" />
      </div> -->
      <div class="inpBox">
        <div class="inp">
          <div class="search">
            <div class="iconfont icon-search"></div>
          </div>
          <div class="shu"></div>
          <input type="text" placeholder="请输入教程名称搜索" name="" id="" />
          <div class="searchBtn">搜索</div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="leftCont">
        <div class="typeList">
          <div
            class="type"
            :class="item.id == typeOn ? 'on' : ''"
            v-for="item in typeList"
            @click="typeClick(item.id)"
          >
            {{ item.name }}
          </div>
        </div>
        <div class="list">
          <div class="li" v-for="item in list" @click="jump(item.id)">
            <div class="img">
              <div class="type">视频</div>
              <img
                :src="
                  item.resources ? $imgUrl + item.resources[0].path_name : ''
                "
                alt=""
                srcset=""
              />
            </div>
            <div class="name">{{ item.name }}</div>
            <div class="box">
              <div class="txt">{{ item.create_time }}</div>
              <div class="money" v-if="item.price != 0">
                <span>￥</span>{{ item.price }}
              </div>
              <div class="money" v-else>免费</div>
            </div>
          </div>
          <div class="fenye" v-if="totalCount > 30">
            <a-pagination
              :default-current="page.pageNo"
              v-model="page.pageNo"
              :total="totalCount"
              :page-size="30"
              @change="pageOnChange"
            />
          </div>
        </div>
      </div>
      <div class="ritCont">
        <div class="headBox">筛选</div>
        <div class="list">
          <div class="li">
            <div class="name">付费</div>
            <div class="texts">
              <div
                class="txt"
                v-for="item in moneyList"
                :class="moneyOn == item.id ? 'on' : ''"
                @click="moneyClick(item.id)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <div class="li">
            <div class="name">年度</div>
            <div class="texts">
              <div
                class="txt"
                v-for="item in yearList"
                :class="yearOn == item.id ? 'on' : ''"
                @click="yearClick(item.id)"
              >
                {{ item.name }}
              </div>
            </div>
          </div>
          <!-- <div class="li">
            <div class="name">季度</div>
            <div class="texts">
              <div class="txt on">全部</div>
              <div class="txt">第一季度</div>
              <div class="txt">第二季度</div>
              <div class="txt">第三季度</div>
              <div class="txt">第四季度</div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoginZj from "../component/loginZj.vue";

export default {
  components: {
    LoginZj,
  },
  name: "",
  data() {
    return {
      typeOn: "",
      typeList: [
        {
          name: "综合排序",
          id: "",
        },
        {
          name: "更新时间",
          id: "a.create_time desc",
        },
        {
          name: "点击次数",
          id: "a.click desc",
        },
      ],
      judge: true,
      page: {
        pageNo: 1,
        pageSize: 30,
      },
      list: [],
      totalCount: 0,
      moneyOn: "",
      moneyList: [
        {
          name: "不限",
          id: "",
        },
        {
          name: "免费",
          id: 1,
        },
        {
          name: "付费",
          id: 2,
        },
      ],
      yearOn: "",
      yearList: [],
    };
  },
  created() {
    let yearList = [];
    const currentYear = new Date().getFullYear();
    yearList.push({
      name: "不限",
      id: "",
    });
    for (let i = currentYear; i > 2022; i--) {
      yearList.push({
        name: i + "年",
        id: i,
      });
    }
    this.yearList = yearList;
    this.listGet();
  },
  methods: {
    moneyClick(i) {
      this.moneyOn = i;
      this.page.price = i;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.list = [];
      this.listGet();
    },
    yearClick(i) {
      this.yearOn = i;
      this.page.year = i;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.list = [];
      this.listGet();
    },
    typeClick(id) {
      this.typeOn = id;
      this.page.odb = id;
      this.page.pageNo = 1;
      this.totalCount = 0;
      this.list = [];
      this.listGet();
    },
    listGet() {
      if (!this.judge) {
        return;
      }
      this.judge = false;
      this.$get("/nozzle/web/train_gets", this.page).then((res) => {
        console.log(res);
        this.judge = true;
        if (this.totalCount == 0) {
          this.totalCount = res.totalCount;
        }
        if (res.data) {
          for (let i = 0; i < res.data.length; i++) {
            const e = res.data[i];
            e.create_time = e.create_time.split(" ")[0];
            this.list.push(e);
          }
        }
      });
    },
    pageOnChange(i) {
      this.list = [];
      this.page.pageNo = i;
      this.listGet();
    },
    jump(id) {
      // this.$router.push({
      //   path: "/pexCont",
      //   query: {
      //     id
      //   },
      // });
      window.open("#/pexCont?id=" + id);
    },
  },
  mounted() {},
  computed: {},
};
</script>
<style lang="less" scoped>
.serchBox {
  display: flex;
  justify-content: center;
  padding: 25px 55px;
  padding-right: 70px;
  padding-bottom: 5px;
  align-items: center;
  width: 1280px;
  margin: auto;
  margin-bottom: 15px;
  box-sizing: border-box;

  .logoImg {
    width: 150px;
  }

  .inpBox {
    width: calc(100% - 70px);
    box-sizing: border-box;

    .inp {
      border: 2px solid #1a78ec;
      background-color: #fff;
      width: 100%;
      height: 50px;
      border-radius: 10px;
      display: flex;
      overflow: hidden;
      align-items: center;
      position: relative;

      .search {
        width: 65px;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;

        .iconfont {
          font-size: 24px;
          color: #999;
        }
      }

      .shu {
        width: 2px;
        height: 20px;
        background-color: #c9c9c9;
      }

      input {
        width: calc(100% - 67px);
        height: 100%;
        padding-left: 20px;
        box-sizing: border-box;
      }

      .searchBtn {
        cursor: pointer;
        width: 90px;
        height: calc(100% - 4px);
        position: absolute;
        right: 2px;
        top: 2px;
        background-color: #1a78ec;
        color: #fff;
        font-weight: 600;
        font-size: 16px;
        border-radius: 5px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }
}

.content {
  margin: auto;
  width: 1280px;
  border-top: 1px solid #e0e0e0;
  padding-top: 10px;
  display: flex;

  .leftCont {
    width: calc(100% - 355px);

    .typeList {
      height: 50px;
      display: flex;
      align-items: center;
      font-size: 16px;
      margin-bottom: 5px;

      .type {
        margin-right: 25px;
        color: #666;
        cursor: pointer;
      }

      .on {
        color: #1677ff;
        font-weight: 600;
      }
    }

    .list {
      overflow: hidden;

      .li {
        width: calc(20% - 12px);
        margin-right: 15px;
        margin-bottom: 15px;
        float: left;
        cursor: pointer;

        .img {
          height: 220px;
          border-radius: 5px;
          overflow: hidden;
          position: relative;

          .type {
            position: absolute;
            top: 0;
            right: 0;
            border-bottom-left-radius: 5px;
            background-color: rgb(0, 192, 255);
            color: #fff;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 12px;
            padding: 5px 10px;
          }

          .fen {
            background-color: rgb(251, 114, 153);
          }

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }

        .name {
          margin-top: 10px;
          font-size: 15px;
          padding: 0 2px;
        }

        .box {
          margin-top: 5px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0 2px;
          color: #888;
          font-size: 13px;

          span {
            font-size: 12px;
          }

          .money1 {
            color: #f83f10;
            font-weight: 600;
          }
        }
      }

      .li:nth-child(5n) {
        margin-right: 0;
      }
    }
  }

  .ritCont {
    width: 355px;
    padding-left: 20px;
    box-sizing: border-box;

    .headBox {
      height: 50px;
      display: flex;
      align-items: center;
      font-weight: 600;
      font-size: 20px;
      color: #333;
      margin-bottom: 5px;
    }

    .list {
      .li {
        display: flex;
        margin-bottom: 15px;
        font-size: 13px;

        .name {
          width: 70px;
          color: #999;
          padding-top: 1px;
        }

        .texts {
          width: calc(100% - 70px);
          display: flex;
          align-items: center;
          flex-wrap: wrap;

          .txt {
            margin-right: 18px;
            margin-bottom: 10px;
            cursor: pointer;
          }

          .on {
            color: #00aeec;
          }
        }
      }
    }
  }
}
</style>
